import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import * as c from '../constants';
import * as actions from '../actions';
// import AreaChartComponent from '../components/AreaChartComponent';
import EbillsDashboardContainer from './EbillsDashboardContainer';

const BillsPaymentDashboardContainer = ({ getCounts, counts }) => {

  useEffect(() => {
    getCounts();
  }, []);

  const returnTransactionData = () => {
    const data = _.get(counts, 'total_e_bills_payment_per_status');
    return {
      label: 'Transactions',
      total: _.get(counts, 'total', 0),
      // photo: ''
      list: [
        { label: 'For Checking', value: _.get(data, 'FOR CHECKING', 0), borderClassName: 'checking' },
        { label: 'Waiting for Payment', value: _.get(data, 'WAITING FOR PAYMENT', 0), borderClassName: 'waiting' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'checking' },
        { label: 'For Printing', value: _.get(data, 'FOR PRINTING', 0), borderClassName: 'paid' },
        { label: 'For Appearance', value: _.get(data, 'FOR APPEARANCE', 0), borderClassName: 'appearance' },
        { label: 'For Pickup', value: _.get(data, 'FOR PICK-UP', 0), borderClassName: 'pickup' },
        { label: 'Rejected', value: _.get(data, 'REJECTED', 0), borderClassName: 'rejected' },
        { label: 'For Delivery', value: _.get(data, 'FOR DELIVERY', 0), borderClassName: 'pickup' },
        { label: 'Printed', value: _.get(data, 'PRINTED', 0), borderClassName: 'paid' },
        { label: 'Received', value: _.get(data, 'RECEIVED', 0), borderClassName: 'received' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
      ],
    }
  };

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col pl-0">
          <div className="row pie">
            <DashboardListCard data={returnTransactionData()} className="mb-2" />
          </div>
        </div>
        <div className="col-8 pr-0">
          {/* TODO: change pie-title to chart-title and apply pie-title's css props later  */}
          <div className="col-12 pie-title text-left">
            <EbillsDashboardContainer />
          </div>
          
        </div>
      </div>
    </div>
  );
};

BillsPaymentDashboardContainer.defaultProps = {
  counts: {},
};

BillsPaymentDashboardContainer.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.item`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BillsPaymentDashboardContainer);
